import {
  UpdateSettingsDocument,
  UpdateSettingsMutation,
  UpdateSettingsMutationVariables
} from '~/data';
import { client } from '~/data/client';
import { SettingsSlice } from './SettingsSlice';

/**
 * Saves user settings on the back-end
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function persistSettings(
  variables: UpdateSettingsMutationVariables
) {
  const result = await client.mutate<
    UpdateSettingsMutation,
    UpdateSettingsMutationVariables
  >({
    mutation: UpdateSettingsDocument,
    variables
  });

  if (result.errors?.length || result.data?.updateSettings?.errors.length) {
    throw new Error('Error saving settings...');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { __typename, ...values } =
    result.data!.updateSettings!.learnerTraining!;

  return values as Pick<SettingsSlice, keyof typeof values>;
}
